import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FileText, PackageX, Siren } from "lucide-react";
import api, { openServerPdf } from "../lib/api";
import { Card, StatusBadge } from "./ui-kit";
import { formatItalianDate } from "../lib/dateUtils";

// Fascia rossa in cima a ogni pagina finché c'è una pratica di ritiro aperta:
// tutto il personale sa quali lotti non usare e non spedire.
export function RecallBanner() {
  const location = useLocation();
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const load = () => api.get("/app/recalls/active").then(({ data }) => setRows(data.recalls || [])).catch(() => {});
    load();
    const timer = window.setInterval(load, 120000);
    window.addEventListener("recalls-changed", load);
    return () => { window.clearInterval(timer); window.removeEventListener("recalls-changed", load); };
  }, []);
  if (!rows.length || location.pathname.startsWith("/app/ritiri/")) return null;
  return <div className="border-b border-red-700 bg-red-600 px-3 py-2.5 text-white sm:px-6" role="alert" data-testid="recall-banner">
    <div className="mx-auto flex max-w-[1400px] flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-2 text-sm">
        <Siren className="mt-0.5 h-4 w-4 shrink-0" />
        <span><strong className="font-semibold">{rows.length === 1 ? "Ritiro in corso" : `${rows.length} ritiri in corso`}:</strong>{" "}
          {rows.map((r) => `${r.origin?.name} lotto ${r.origin?.lot}`).join(" · ")}. Non usare e non spedire questi lotti.</span>
      </div>
      <Link to={rows.length === 1 ? `/app/ritiri/${rows[0].id}` : "/app/ritiri"} className="inline-flex min-h-[40px] shrink-0 items-center justify-center rounded-lg bg-white px-4 text-sm font-semibold text-red-700 hover:bg-red-50" data-testid="recall-banner-open">Apri la pratica</Link>
    </div>
  </div>;
}

const STATUS = { aperto: ["rosso", "In corso"], chiuso: ["verde", "Chiusa"], annullato: ["grigio", "Annullata"] };

// Per Ispezione ASL/NAS: le pratiche di ritiro con il loro PDF.
export function RecallInspectionCard() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/app/recalls").then(({ data }) => setRows(data.recalls || [])).catch(() => setRows([])); }, []);
  return <Card className="p-4 sm:p-6" data-testid="inspection-recalls">
    <h2 className="mb-1 flex items-center gap-2 font-heading text-xl font-semibold text-navy"><PackageX className="h-5 w-5" /> Ritiri e richiami</h2>
    <p className="mb-4 text-sm text-slate-500">Pratiche di ritiro dal commercio e di richiamo, con prodotti bloccati, destinatari avvisati ed esito.</p>
    {!rows ? null : rows.length === 0 ? <p className="text-sm text-slate-500">Nessun ritiro registrato.</p>
      : <ul className="divide-y divide-hairline">{rows.map((r) => <li key={r.id} className="flex flex-col gap-2 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0 text-sm"><span className="font-medium text-navy">Pratica n. {r.number_label}</span> <StatusBadge status={STATUS[r.status]?.[0]}>{STATUS[r.status]?.[1]}</StatusBadge>
          <div className="text-xs text-slate-500">{r.origin?.name} · lotto {r.origin?.lot} · {formatItalianDate(r.created_at)}</div></div>
        <button type="button" onClick={() => openServerPdf(`/app/recalls/${r.id}/pdf`)} className="inline-flex min-h-[44px] shrink-0 items-center justify-center gap-2 rounded-lg border border-navy px-4 text-sm font-medium text-navy hover:bg-slate-50"><FileText className="h-4 w-4" /> PDF</button>
      </li>)}</ul>}
  </Card>;
}
